// extracted by css-extract-rspack-plugin
module.exports =  {"pendingActions":"DraftApproved__pendingActions___zcz4J"};